import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function NotFound() {
  return (
    <section className="mx-auto flex max-w-[1240px] flex-col items-center px-4 py-24 text-center md:px-6">
      <span className="font-heading text-7xl font-black text-primary-500 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
        这个页面被吃掉啦
      </h1>
      <p className="mt-3 max-w-md text-sm leading-7 text-foreground-500">
        你访问的页面可能已经下架或者链接有误。不如回首页看看今天最热的瓜。
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
      >
        <i className="ri-home-5-line" aria-hidden="true" />
        返回首页
      </Link>

      <div className="mt-10 flex flex-wrap justify-center gap-2">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="cursor-pointer whitespace-nowrap rounded-full border border-background-300/80 px-4 py-1.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            {c.name}
          </Link>
        ))}
      </div>
    </section>
  );
}